import http from './_http'

const profile = {
  get: () => http.get(`api.user/auth/profile`),
  update: (m) => http.put(`api.user/auth/profile`, m),
}

export default profile